module.exports = __webpack_public_path__ + "static/manage-search-ace725bb095eca99da44228a48f4c8e5.png";